import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class CreateApplicationDetailsEhmsConstants {
    static STEP_TITLE = "Details";
    static DESCRIPTION_LABEL = "Description";
    static APPLICATION_TYPE_LABEL = "Application type";
    static START_DATE_LABEL = "Application Start Date";
    static COMMUNICATION_METHOD_LABEL = "Communication Method";
    static DESCRIPTION_FORM_CONTROL_NAME = "description";
    static APPLICATION_TYPE_FORM_CONTROL_NAME = "applicationType";
    static START_DATE_FORM_CONTROL_NAME = "startDate";
    static COMMUNICATION_METHOD_FORM_CONTROL_NAME = "communicationMethod";
    static VALIDATION_MESSAGES = {
        description: {
            required: `Description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        applicationType: {
            required: `Application type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
    };
}
